'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product order price
 */
    .directive('capOrderProductPrice', function () {
        return {
            restrict: 'A',
            scope: {
                price: "=",
                exemptedFromTax: "=",
                minimumCommitmentPeriodText: "=",
                minimumCommitmentPeriodOverrideText: "=",
                regularPriceOverrideText: "=",
                promotionPriceOverrideText: "=",
                promotionTypeOptin: "=",
                afterOptinInfoText: "=",
                beforeOptinInfoText: "=",
                optinSelected: "=",
                change: "=",
                a: "="
            },
            templateUrl: "templates/orderproductprice.html"
        }
    });